import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/api";
import { useSiteContent } from "@/context/SiteContentContext";

export const WhatsAppButton = ({ message }) => {
  const { content } = useSiteContent();
  const contact = content.contact;
  const msg = message || contact.default_whatsapp_message;
  return (
    <a
      href={WHATSAPP_LINK(msg, contact.whatsapp_number)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="WhatsApp ile iletişime geç"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[var(--gold)]/40 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[var(--navy)] border border-[var(--gold)] shadow-[0_10px_30px_rgba(10,25,47,0.35)] transition-all duration-300 group-hover:bg-[var(--gold)] group-hover:border-[var(--navy)]">
        <MessageCircle size={22} className="text-[var(--gold)] group-hover:text-[var(--navy)] transition-colors" />
      </span>
    </a>
  );
};

export default WhatsAppButton;
